export const scrollToSection = (id, updateHash = true) => {
  const target = document.getElementById(id);
  if (!target) return false;

  const utilityBarHeight = 40;
  const headerHeight = 96;
  const spacing = 20;

  const headerNav = document.getElementById("multibrand-header-nav");
  const headerCollapsed = headerNav
    ? getComputedStyle(headerNav).transform !== "none"
    : false;

  const onThisPage = document.getElementById("on-this-page");
  const onThisPageHeight =
    onThisPage && getComputedStyle(onThisPage).position === "sticky"
      ? onThisPage.offsetHeight
      : 0;

  const offset =
    utilityBarHeight +
    (headerCollapsed ? 0 : headerHeight) +
    onThisPageHeight +
    spacing;

  window.scrollTo({
    top: target.getBoundingClientRect().top + window.pageYOffset - offset,
    behavior: "smooth",
  });

  if (updateHash) {
    window.history.replaceState(null, "", `#${id}`);
  }

  return true;
};